import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setTabItemsExpend, activateTab, setPopUp, resetBlock, reportAnalytics} from '../TabsContainerBlock/TabsContainerSlice';
import noImage from './images/no-image.png';
import Config from '../../../Config';
import {Col, Row, Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import gaParams from '../../../utilities/analytics/constants';

const AbroadPerfectPackage = (props) => {
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);

    const tabItems = props.data.tabsContentArea?.expandedValue?.map((item, i) => ({
      active: false,
      id: i,
      tabName: item.tabName.value,
      mobileTabName: item.mobileTabName.value,
      icon: item.icon.value ? Config.epiBaseUrl + item.icon.value.url : noImage,
      mobileIcon: item.mobileIcon.value ? Config.epiBaseUrl + item.mobileIcon.value.url : noImage,
      contentTitle: item.contentTitle.value,
      subContentTitle: item.subContentTitle.value != null ? item.subContentTitle.value : null,
      listItems: item.listItemsContentArea?.expandedValue != null ? item.listItemsContentArea?.expandedValue : null,
    }));

    props.setTabItemsExpend({items: tabItems});

    return () => {
      window.removeEventListener('scroll', trackScrolling);
      props.resetBlock();
    };
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [props.activeLobbyTab, props.abroadPackagesList]);
  const trackScrolling = () => {
    const wrappedElement = document.getElementById('tabs-container-perfect');
    if (isBottom(wrappedElement)) {
      if (props.activeLobbyTab == 'businessAccount') {
        if (props.otpData.validatedCostumerData?.isSeparatedSale) {
          props.reportAnalytics({
            eventCategory: gaParams.SEPARATED_WHYBUYPACKAGE_SHOW.category,
            eventAction: gaParams.SEPARATED_WHYBUYPACKAGE_SHOW.eventType,
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        } else {
          props.reportAnalytics({
            eventCategory: 'hul_sale_business',
            eventAction: 'visibility_18',
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        }
      } else {
        if (!props.businessIndividual) {
          props.reportAnalytics({
            eventCategory: 'hul_sale_private',
            eventAction: 'visibility_10',
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        }
      }

      window.removeEventListener('scroll', trackScrolling);
    }
  };

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  const selectTab = (tabId) => {
    props.activateTab({id: tabId, items: props.tabItems, isMobile: isMobile});
  };

  const closePopUp = () => {
    props.setPopUp({status: false});
  };

  return (
    <div className='container-fluid main'>
      <div id='tabs-container-perfect' className='tabs-container-perfect'>
        <div className='div-separator'></div>

        <h2 dangerouslySetInnerHTML={{__html: isMobile ? props.data.mobileTitle.value : props.data.title.value}}></h2>

        <h3>{isMobile ? props.data.mobileSubTitle.value : props.data.subTitle.value}</h3>
        <br />

        <Row style={{textAlign: 'center'}}>
          <Col>
            <div className='tab-row'>
              <Row>
                {props.tabItemsExpend?.map((item, i) => (
                  <Col
                    className='col'
                    key={item.id}
                    style={
                      i % 2 == 0 && isMobile
                        ? {paddingRight: '0px', paddingLeft: '0px', borderLeft: '1px solid #e0e5e8'}
                        : {paddingRight: '0px', paddingLeft: '0px', borderLeft: '0px'}
                    }>
                    <div className='tabItem' style={{cursor: 'default'}}>
                      <div className='tabItem__center-div'>
                        <div className='image'>
                          <Image style={{maxWidth: '70px', maxHeight: '71px'}} src={isMobile ? item.mobileIcon : item.icon} />
                        </div>
                        <span className='title'>{isMobile ? item.mobileTabName : item.tabName}</span>
                      </div>
                    </div>
                    <div className='div_separator'></div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    tabItemsExpend: state.tabsContainer.tabItemsExpend,
    contentTitle: state.tabsContainer.contentTitle,
    contentSubTitle: state.tabsContainer.contentSubTitle,
    listItems: state.tabsContainer.listItems,
    isMobileView: state.tabsContainer.isMobile,
    showPopUp: state.tabsContainer.isShowPopUp,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    abroadPackagesList: state.cellcomAbroad.abroadPackagesList,
    otpData: state.cellcomAbroad.otpData,
    businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
  };
};

const mapDispatchToProps = {
  setTabItemsExpend,
  activateTab,
  setPopUp,
  resetBlock,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadPerfectPackage);
